import { Link } from 'react-router-dom'
import {
  isPaidSubscriptionExpired,
  needsSubscriptionPlan,
  storedSubscriptionEndDate,
} from '../../utils/subscriptionAccess'

function formatEndedOn(raw) {
  if (!raw) {
    return ''
  }
  const match = String(raw).match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (match) {
    return `${match[3]}-${match[2]}-${match[1]}`
  }
  return String(raw)
}

/**
 * Sticky left-menu banner for subscription action.
 * - expired: renew an ended plan
 * - required: no active plan yet (new or grandfathered without a subscription)
 */
const SubscriptionExpiredSidebarNotice = ({
  visibleExpired,
  visibleRequired,
}) => {
  const expired = visibleExpired !== false && (visibleExpired || isPaidSubscriptionExpired())
  const required = !expired
    && visibleRequired !== false
    && (visibleRequired || needsSubscriptionPlan())

  if (!expired && !required) {
    return null
  }

  if (expired) {
    const endedOn = formatEndedOn(storedSubscriptionEndDate())
    return (
      <Link
        to="/subscription-management?tab=purchase"
        className="sidebar-sub-expired"
        title="Open subscription management to renew"
      >
        <span className="sidebar-sub-expired__badge">Action needed</span>
        <p className="sidebar-sub-expired__title">Subscription expired</p>
        <p className="sidebar-sub-expired__meta">
          {endedOn ? `Ended on ${endedOn}. ` : ''}
          Renew now to keep using Petrosmart.
        </p>
        <span className="sidebar-sub-expired__cta">Go to subscription page</span>
      </Link>
    )
  }

  return (
    <Link
      to="/subscription-management?tab=purchase"
      className="sidebar-sub-expired sidebar-sub-expired--required"
      title="Open subscription management to choose a plan"
    >
      <span className="sidebar-sub-expired__badge">Action needed</span>
      <p className="sidebar-sub-expired__title">No active subscription</p>
      <p className="sidebar-sub-expired__meta">
        Choose a free trial or paid plan on the subscription page.
      </p>
      <span className="sidebar-sub-expired__cta">Go to subscription page</span>
    </Link>
  )
}

export default SubscriptionExpiredSidebarNotice
